/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Val3_DescInputs */

const en_st_val3_desc = /** @type {(inputs: St_Val3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD, codebase wiki, evidence log, overrides, estimate vs actual, deploy guide and a security checklist — a single ZIP at the end of the project.`)
};

const id_st_val3_desc = /** @type {(inputs: St_Val3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD, wiki codebase, log bukti, daftar override, estimasi vs aktual, panduan deploy, dan checklist keamanan — satu ZIP di akhir proyek.`)
};

/**
* | output |
* | --- |
* | "PRD, codebase wiki, evidence log, overrides, estimate vs actual, deploy guide and a security checklist — a single ZIP at the end of the project." |
*
* @param {St_Val3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_val3_desc = /** @type {((inputs?: St_Val3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Val3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_val3_desc(inputs)
	return en_st_val3_desc(inputs)
});